import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  deleteLocalCartItem,
  updateProductQuantity
} from '../../../../store/actions';

function useValidateCartGuest() {
  const [errors, setErrors] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();

  const validateCartGuestData = location?.state?.validateCartGuestData;

  const productsIdsToRemove =
    validateCartGuestData?.productIdsToRemoveFromLocalCart;

  const productIdsToReduceQuantityFromLocalCart =
    validateCartGuestData?.productIdsToReduceQuantityFromLocalCart;

  useEffect(() => {
    if (
      productsIdsToRemove?.length ||
      productIdsToReduceQuantityFromLocalCart?.length
    ) {
      if (productsIdsToRemove?.length) {
        handleProductsToRemove();
      }

      if (productIdsToReduceQuantityFromLocalCart?.length) {
        handleProductsToReduceQuantity();
      }

      handleErrors();
    }
  }, [productsIdsToRemove?.length]);

  const handleProductsToReduceQuantity = () => {
    productIdsToReduceQuantityFromLocalCart.map(product => {
      return dispatch(
        updateProductQuantity({
          productId: parseInt(product.product_id),
          quantity: product.current_inventory
        })
      );
    });
  };

  const handleProductsToRemove = () => {
    productsIdsToRemove.map(productId => {
      return dispatch(deleteLocalCartItem(parseInt(productId)));
    });
  };

  const handleErrors = () => {
    {
      const data = location?.state?.validateCartGuestData;
      if (!data) return;

      let errors = [];
      if (data.isNotPurchasable.length > 0) {
        errors.push(
          'The following products were removed from your cart as they are not longer available: ' +
            data.isNotPurchasable.join()
        );
      }

      if (data.productsWithNotEnoughInventory.length > 0) {
        errors.push(
          `We've reduced the quantity of the following products because there is not 
          enough stock: ${data.productsWithNotEnoughInventory.join()}`
        );
      }

      if (errors.length > 0) {
        setErrors(errors);
      }
    }
  };

  return [errors];
}

export default useValidateCartGuest;
